module.exports = "/fonts/SoberanaSans-Regular.otf?9bc328b309a71105697764add22b822c";